import axios from 'axios'
import config from './config'
import auth from '../auth'
var firebase = window.firebase

/**
 * Get a list of available plans
 * @returns {promise}
 */
function listPlans () {
  return auth.getAuthToken()
    .then(function (token) {
      return axios
        .get(`${config.API_BASE_URL}/admin/subscription/plans`, {
          params: {authToken: token}
        })
        .then(function (res) {
          return res.data
        })
    })
}

/**
 * Change an account's plan
 * @param {string} subscriptionId a valid Stripe subscriptionId
 * @param {string} planId a valid Stripe planId
 * @param {boolean} charge whether to charge the plan immediately
 * @param {boolean} retainTrial keep trial if one exists
 */
function changePlan (subscriptionId, planId, charge, retainTrial) {
  return auth.getAuthToken()
    .then(function (token) {
      return axios
        .post(`${config.API_BASE_URL}/admin/subscription/changePlan`, {
          authToken: token,
          subscription: subscriptionId,
          plan: planId,
          charge: charge,
          retainTrial: retainTrial
        })
        .then(function (res) {
          return res.data
        })
    })
}

/**
 * Pause a user's account
 * @param {string} accountId
 * @returns {promise}
 */
function pause (accountId) {
  return firebase
    .auth()
    .currentUser
    .getIdToken()
    .then(function (token) {
      return axios
        .post(`${config.API_BASE_URL}/admin/subscription/pause`, {
          authToken: token,
          accountId: accountId
        }).catch(function (res) {
          return Promise.reject(res.response.data.error)
        })
    })
}

/**
 * Unpause a user's account
 * @param {string} accountId
 * @returns {promise}
 */
function unpause (accountId) {
  return firebase
    .auth()
    .currentUser
    .getIdToken()
    .then(function (token) {
      return axios
        .post(`${config.API_BASE_URL}/admin/subscription/unpause`, {
          authToken: token,
          accountId: accountId
        }).catch(function (res) {
          return Promise.reject(res.response.data.error)
        })
    })
}

export default {
  listPlans,
  changePlan,
  pause,
  unpause
}



// WEBPACK FOOTER //
// ./src/api/billing.js